import { useAppDispatch } from 'appState/store'
import { LoadingAnimation } from '@outbound-ai/ursa'
import { Button } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { isCurrentUserOutboundUser } from 'utils/helper'
import { notificator } from 'utils/notificator/notificator'

import { updateCurrentFiles } from '../FileShareSlice'
import {
  FileExchangeSourceEnum,
  FileExchangeTypeEnum,
  FileShareRequestBody,
  FileShareTabType,
} from '../types/FileShareEnums'
import { fileShareFileUpload } from '../utils/fileShareApi'

// paths
// components
// types and utils
// features
export interface IProps {
  file: File | null
  comment?: string
  loading: boolean
  onIsLoading: (status: boolean) => void
  onRemoveFile: () => void
  closeModal: () => void
}

export const FileShareFileUploadButton = ({ file, comment, loading, onIsLoading, closeModal }: IProps) => {
  const dispatch = useAppDispatch()
  const isOutboundUser = isCurrentUserOutboundUser()
  const fileSource = isOutboundUser ? FileExchangeSourceEnum.OutboundAi : FileExchangeSourceEnum.Customer

  const fileUploadHandler = async () => {
    if (!file) return
    onIsLoading(true)

    const body: FileShareRequestBody = {
      File: file,
      ExchangeSource: fileSource,
      ExchangeType: FileExchangeTypeEnum.Onboarding,
      Comments: comment,
    }
    fileShareFileUpload(body)
      .then(() => {
        dispatch(updateCurrentFiles({ root: FileShareTabType.Files, refresh: true }))
        onIsLoading(false)
        closeModal()
        notificator.notify({ type: 'success', heading: `${file.name} has been successfully uploaded` })
        //notificator.success(`${file.name} has been successfully uploaded`)
      })
      .catch(() => {
        dispatch(updateCurrentFiles({ root: FileShareTabType.Files, refresh: true }))
        onIsLoading(false)
        closeModal()
        notificator.notify({ type: 'error', heading: `${file.name} has been failed uploaded` })
        //notificator.error(`${file.name} has been failed uploaded`)
      })
  }

  return (
    <Div>
      <Button
        width="100%"
        data-testid="file-upload-btn"
        variant="info"
        radius="rounded"
        className="btn-validate"
        disabled={!file}
        size="large"
        color="info"
        onClick={fileUploadHandler}
      >
        {loading ? (
          <>
            <LoadingAnimation variant="light" />
            <span>Processing...</span>
          </>
        ) : (
          `Upload`
        )}
      </Button>
    </Div>
  )
}

const Div = styled.div`
  width: 100%;
  .btn-start-over {
    width: 100%;
  }
`
